import { SearchIcon } from "@chakra-ui/icons";
import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
  InputRightElement,
} from "@chakra-ui/react";
import { useState, useEffect, useRef } from "react";
import { FiArrowRight, FiX } from "react-icons/fi";

export function PatientSearch({
  onSearch,
  onClear,
  isLoading,
}: {
  onSearch: (query: string) => void;
  onClear: () => void;
  isLoading: boolean;
}) {
  const [searchQuery, setSearchQuery] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        inputRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      if (searchQuery.length < 1) {
        setSearchQuery("");
        onClear();
      } else {
        onSearch(searchQuery);
      }
    }
  };

  const handleClear = () => {
    setSearchQuery("");
    onClear();
  };

  return (
    <InputGroup mb={0.5} maxW="750px" mx={"auto"}>
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="gray.300" />
      </InputLeftElement>
      <Input
        pr={"70px"}
        ref={inputRef}
        bg={useColorModeValue("white", "gray.800")}
        placeholder="Search Medical History..."
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
        onKeyDown={handleKeyPress}
        _hover={{ borderColor: "#879ced" }}
        _focus={{ borderColor: "#879ced" }}
        isDisabled={isLoading}
      />
      <InputRightElement w="auto" pr={2}>
        {searchQuery.length > 0 && (
          <IconButton
            isDisabled={isLoading}
            icon={<Icon as={FiX} />}
            size="xs"
            aria-label="Clear search"
            onClick={handleClear}
            variant="ghost"
            color="gray.600"
            borderRadius="full"
            mr={1}
            bg={"gray.100"}
            _hover={{
              bg: "gray.200",
              color: "gray.800",
            }}
          />
        )}
        <IconButton
          isDisabled={isLoading}
          icon={<Icon as={FiArrowRight} />}
          size="xs"
          aria-label="Search"
          onClick={() => onSearch(searchQuery)}
          variant="solid"
          bg={"#879ced"}
          color={"white"}
          borderRadius="full"
          _hover={{
            bg: "#748df0",
            color: "white",
          }}
          _active={{
            bg: "#6477d9",
          }}
        />
      </InputRightElement>
    </InputGroup>
  );
}
